// NPM
import React from "react"

// Shared Components
import CommonHero from 'src/components/Shared/CommonHero'
import InfoImage from 'src/components/Shared/InfoImage'
import ToolTypes from 'src/components/Shared/ToolTypes'
import WorkTogether from 'src/components/Shared/WorkTogether'

// About Components
import OurMission from './OurMission'
import OurProcess from './OurProcess'
import TeamMembers from './TeamMembers'
import Advisors from './Advisors'

const About = ({ sections, teamMembers, advisors }) => {
  return (
    <div className="About">
      <CommonHero section={ sections.find(s => s.uuid === "aboutUs_title") } />

      <div className="InfoImage__items">
        <InfoImage section={ sections.find(s => s.uuid === "aboutUs_01") } />
        <InfoImage section={ sections.find(s => s.uuid === "aboutUs_02") } />
        <InfoImage section={ sections.find(s => s.uuid === "aboutUs_03") } />
        <InfoImage section={ sections.find(s => s.uuid === "aboutUs_04") } />
      </div>

      <OurMission section={ sections.find(s => s.uuid === "aboutUs_ourMission") } />
      <OurProcess sections={ sections } />

      <TeamMembers 
        sections={ sections }
        teamMembers={ teamMembers}
      />

      {/* <Advisors
        sections={ sections }
        advisors={ advisors }
      /> */}

      <ToolTypes sections={ sections } />
      <WorkTogether section={ sections.find(s => s.uuid === "workTogether") } />
    </div>
  )

}

export default About